"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _models = require("@nopanoga/models");

var _Util = require("../Util");

var _LinearGradient = _interopRequireDefault(require("../LinearGradient"));

var _Text = require("../Text");

var _Icons = _interopRequireDefault(require("../Icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = _reactNative.StyleSheet.create({
  absoluteIndicator: {
    position: 'absolute',
    zIndex: 14,
    height: 88,
    width: '100%'
  },
  infosContainer: {
    position: 'absolute',
    zIndex: 2,
    width: '100%',
    height: '100%',
    paddingHorizontal: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  gradient: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0
  }
});

var _default = function _default(_ref) {
  var timer = _ref.timer,
      onClickClose = _ref.onClickClose;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.absoluteIndicator
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.infosContainer
  }, timer && /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    color: "white",
    style: {
      fontSize: 28
    }
  }, (0, _Util.renderTime)(timer, 'short')), /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    onPress: onClickClose
  })), /*#__PURE__*/_react["default"].createElement(_LinearGradient["default"], {
    style: [styles.gradient]
  }));
};

exports["default"] = _default;